$(document).ready(function () {

    // Things to hide on click

    $('body').click(function () {
        if ($('.c-share--visible').length > 0) {
            $('.js-share-container').removeClass('c-share--visible');
        }
    });

    if ($('.js-ad-detail-location').html().length < 1) {
        $('.js-ad-detail-location').hide();
    }

    // Hide second bar if first on is visible


    $(window).on('scroll', function () {
        var top_of_element = $(".js-detail-info-0").offset().top;
        var bottom_of_element = $(".js-detail-info-0").offset().top + $(".js-detail-info-0").outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
            $('.js-detail-info-1').slideUp(200);
        } else {
            $('.js-detail-info-1').slideDown(200);
        }
    });


    // Gallery functions

    if ($('.js-gallery').length != 0) {
        (function () {
            var currentSlide = 1;
            var listIsOpen = false;
            var detailIsOpen = false;
            var totalSlides = $('.js-gallery-item').length;
            var cacheNext = "";
            var cachePrev = "";

            /* TODO Ota - loader */

            function changeSlide(id, source, alt) {
                if (id >= totalSlides && totalSlides != 1) {
                    $('.js-gallery-next').hide();
                    $('.js-gallery-prev').show();
                    id = totalSlides;
                } else if (id <= 1 && totalSlides != 1) {
                    $('.js-gallery-next').show();
                    $('.js-gallery-prev').hide();
                    id = 1;
                } else if (totalSlides == 1) {
                    $('.js-gallery-next, .js-gallery-prev').hide();
                } else {
                    $('.js-gallery-next, .js-gallery-prev').show();
                }

                if (id <= totalSlides && id >= 1) {
                    $('.js-gallery-current').html(id);
                    $('.js-gallery-large-pic').attr('src', source);
                    $('.js-gallery-large-pic').attr('alt', alt);
                    currentSlide = id;
                    if (currentSlide != totalSlides) { 
                        nextImage = currentSlide + 1;
                        const nextImageElement = $(".js-gallery").find("[data-gallery-id='" + nextImage + "']");
                        cacheNext = nextImageElement.data('gallery-full-url');

                        $('.js-gallery-cache-next').attr('src', cacheNext);
                        //TODO(HICZDE-1358): when SEO testings is done always copy alt
                        if ($('.js-gallery-cache-next').attr('alt')) {
                            $('.js-gallery-cache-next').attr('alt', nextImageElement.attr('alt'));
                        }
                    }
                    if (currentSlide != 1) {
                        prevImage = currentSlide - 1;
                        const prevCacheImageElement = $(".js-gallery").find("[data-gallery-id='" + prevImage + "']");
                        cachePrev = prevCacheImageElement.data('gallery-full-url');
                        
                        $('.js-gallery-cache-prev').attr('src', cachePrev);
                        //TODO(HICZDE-1358): when SEO testings is done always copy alt
                        if ($('.js-gallery-cache-prev').attr('alt')) {
                            $('.js-gallery-cache-prev').attr('alt', prevCacheImageElement.attr('alt'));
                        }
                    }
                }
            }

            function slideGallery(direction) {
                if (direction == "prev" && currentSlide > 1) {
                    currentSlide -= 1;
                    $('.js-gallery-large-pic').addClass('move-right');

                    setTimeout(function () {
                        $('.js-gallery-large-pic').removeClass('move-right');
                    }, 300);
                } else if (direction == "next" && currentSlide < totalSlides) {
                    currentSlide += 1;
                    $('.js-gallery-large-pic').addClass('move-left');

                    setTimeout(function () {
                        $('.js-gallery-large-pic').removeClass('move-left');
                    }, 300);
                }

                setTimeout(function () {
                    var source = $(".js-gallery").find("[data-gallery-id='" + currentSlide + "']").data('gallery-full-url');
                    var alt = $(".js-gallery").find("[data-gallery-id='" + currentSlide + "']").attr('alt');
                    changeSlide(currentSlide, source, alt);
                }, 100);
            }

            // Set numbers for gallery detail

            $('.js-gallery-total').html(totalSlides);

            // Set IDs

            $('.js-gallery-item').each(function (i) {
                $(this).attr('data-gallery-id', i + 1);
            });

            $('.js-gallery-preview-image').each(function (i) {
                $(this).attr('data-gallery-id', i + 1);
            });

            $(window).bind('load', function () {
                $('.js-gallery-preview-image').each(function (i) {

                    if ($(this).width() >= $(this).height()) {
                        $(this).addClass('js-landscape');
                    } else {
                        $(this).addClass('js-portrait');
                    }
                });
            });

            // Open gallery list

            $(document).on('click', '.js-open-gallery-list', function (e) {
                $('.js-gallery-list').addClass('c-gallery-list--visible');
                $('.js-gallery-detail').removeClass('c-gallery-detail--visible');
                $('body').addClass('u-no-scroll');
                listIsOpen = true;
                detailIsOpen = false;

                setTimeout(function () {
                    if ($('.js-gallery').height() >= $('.js-gallery-list').height()) {
                        $('.js-gallery-list').addClass('c-gallery-list--overflow');
                    } else {
                        $('.js-gallery-list').removeClass('c-gallery-list--overflow');
                    }
                }, 200);
            });

            // Open gallery detail

            $(document).on('click', '.js-open-gallery-detail', function (e) {
                $('.js-gallery-list').removeClass('c-gallery-list--visible');
                $('.js-gallery-detail').addClass('c-gallery-detail--visible');
                $('body').addClass('u-no-scroll');
                listIsOpen = false;
                detailIsOpen = true;
            });

            // Close gallery

            $(document).on('click', '.js-gallery-close', function (e) {
                $('.js-gallery-list').removeClass('c-gallery-list--visible');
                $('.js-gallery-detail').removeClass('c-gallery-detail--visible');
                $('body').removeClass('u-no-scroll');
                listIsOpen = false;
                detailIsOpen = false;
            });

            // Handle click on gallery item

            $(document).on('click', '.js-gallery-item, .js-gallery-preview-image', function (e) {
                var source = $(this).data('gallery-full-url');
                var alt = $(this).attr('alt');
                var ID = $(this).data('gallery-id');
                detailIsOpen = true;

                changeSlide(ID, source, alt);

                $('.js-gallery-list').removeClass('c-gallery-list--visible');
                $('.js-gallery-detail').addClass('c-gallery-detail--visible');
            });

            // Handle mousewheel


            $('.js-gallery-detail').bind('mousewheel DOMMouseScroll', function (e) {
                e.preventDefault();

                console.log(e.originalEvent.wheelDelta);

                if (e.type == 'mousewheel') {
                    if (e.originalEvent.wheelDelta > 0) {
                        slideGallery('prev');
                    } else {
                        slideGallery('next');
                    }
                }
                else if (e.type == 'DOMMouseScroll') {
                    if (e.originalEvent.detail > 0) {
                        slideGallery('next');
                    } else {
                        slideGallery('prev');
                    }
                }
            });

            // Handle Arrows

            // Prev

            $(document).on('click', '.js-gallery-prev', function (e) {
                slideGallery('prev');
            });

            // Next

            $(document).on('click', '.js-gallery-next', function (e) {
                slideGallery('next');
            });

            // Handle key press

            $('body').keydown(function (e) {
                if (e.keyCode == 37 && detailIsOpen == true) {
                    slideGallery('prev');
                } else if (e.keyCode == 39 && detailIsOpen == true) {
                    slideGallery('next');
                } else if (e.keyCode == 27 && detailIsOpen == true) {
                    $('.js-gallery-detail').removeClass('c-gallery-detail--visible');
                    $('body').removeClass('u-no-scroll');
                    detailIsOpen = false;
                } else if (e.keyCode == 27 && listIsOpen == true) {
                    $('.js-gallery-list').removeClass('c-gallery-list--visible');
                    $('body').removeClass('u-no-scroll');
                    listIsOpen = false;
                }
            });

            // Swipe

            $('.js-gallery-large-pic').swipe({
                swipe: function (event, direction) {

                    if (direction == 'right') {
                        if (currentSlide != 1) {
                            slideGallery('prev');
                        }
                    } else if (direction == 'left') {
                        if (currentSlide != totalSlides) {
                            slideGallery('next');
                        }
                    }
                }
            });

            // Gallery slick

            function initSlickSliderDetail() {
                $('.js-gallery').slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true
                });
                $('.js-gallery').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    if(currentSlide < nextSlide) {
                        $('.slick-current-slide').addClass('move');
                        $('.slick-arrow').addClass('move-left');
                    }
                    else {
                        $('.slick-current-slide').addClass('move');
                        $('.slick-arrow').addClass('move-right');
                    }
                });

                $('.js-gallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
                    $('.slick-arrow').removeClass('move-left move-right');
                    $('.slick-current-slide').removeClass('move');
                });
            };

            if ($(window).width() <= 1024) {
                initSlickSliderDetail();
                $('.js-gallery').removeClass('c-gallery-list__item-container--loading');
            }

            else {
                $('.js-gallery').removeClass('c-gallery-list__item-container--loading');
            }

            window.addEventListener("resize", function () {
                if ($(window).width() <= 1024 && !$('.js-gallery').hasClass('slick-initialized')) {
                    initSlickSliderDetail();
                } else if ($(window).width() >= 1024 && $('.js-gallery').hasClass('slick-initialized')) {
                    $('.js-gallery').slick('unslick');
                }
            });
        })();
    }

    // Message popup

    $('.c-ad-detail__info-button.js-toggle-message-popup').each(function () {
        if ($(this).data('type') == 'SupplyEnum') {
            $(this).html('Mám zájem');
        }
        else {
            $(this).html('Reagovat');
        }
    });

    $(document).on('click', '.js-toggle-message-popup', function (e) {
        e.preventDefault();

        // Show message popup if user is logged in, otherwise redirect to login form
        if ($('#js-message-popup-email').length || $('#IsUserLogged').val() === "True") {
            messagePopup();

            const rootCategoryName = $('.root-category-name').text();

            window.dataLayer.push({
                'event': 'user-action',
                'category': 'Inzerat',
                'action': 'Odpoved',
                'section': rootCategoryName
            });
        } else {
            // We need to first set fragment to know where to return from login
            window.location.hash = '#message';
            $('.js-log-in').trigger('click');
        }
    });

    $(document).on('click', '.o-button--popup-close.js-toggle-message-popup', function (e) {
        window.location.hash = '';
    });

    if (window.location.hash === '#message') {
        // Check if exist popup and button for message
        // Message button does not exist for the logged ad owner
        if ($('#send-message').length && $('.js-interest-button').length) {
            messagePopup();
        }
    }

    // Share popup in detail

    $('.js-toggle-share').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".js-copy-url").text("Kopírovat do schránky");
        $('.js-share-container').toggleClass('c-share--visible');
    });

    $(document).on('click', '.js-close-share', function (e) {
        e.preventDefault();
        $('.js-share-container').removeClass('c-share--visible');
    });

    $('.js-copy-url').click(function (e) {
        e.preventDefault();
        copyUrl();
        $(".js-copy-url").text("Adresa zkopírována!");
    });

    $('.js-share-container').click(function (e) {
        if (!e.target.classList.contains('js-close-share')) {
            e.stopPropagation();
        }
    });

    // Print

    $(document).on('click', '.js-detail-print', function (e) {
        e.preventDefault();

        const adIdentifier = $(".user-ad-identifier").val();
        window.dataLayer.push({
            'event': 'user-action',
            'category': 'Inzerat',
            'action': 'Vytisknout',
            'label': adIdentifier
        });
        window.print();
    });


    // Report

    $(document).on('click', '.js-report-popup-toggle', function (e) {
        e.preventDefault();
        $('.js-report-popup').toggleClass('c-popup--visible');
    });

    $('.js-report-select').change(function () {
        if ($(this).val() == 'other') {
            $('.js-report-other-container').find('textarea').removeAttr('disabled');
            $('.js-report-other-container').removeClass('c-popup__input-container--hidden');
        }
        else {
            $('.js-report-other-container').find('textarea').attr('disabled', 'disabled');
            $('.js-report-other-container').addClass('c-popup__input-container--hidden');
        }
    });

    $(document).on('click', '.js-report-button', function (e) {
        e.preventDefault();

        var $reportButton = $(this);
        var $form = $('#js-report-form');

        if ($form.valid()) {
            $reportButton.attr('disabled', 'disabled');
            $.ajax({
                url: '/inzeraty/Report',
                method: 'POST',
                data: $form.serialize(),
                success: function () {
                    $('.js-report-content').hide();
                    $('.js-report-message').removeClass('c-popup__message--hidden');

                    setTimeout(function () {
                        $('.js-report-popup').removeClass('c-popup--visible');
                    }, 5000);
                },
                error: function (ressponse) {
                    $('.js-report-popup').removeClass('c-popup--visible');
                    $reportButton.removeAttr('disabled');

                    let flashMessageContent = "Při nahlašování došlo k chybě.";

                    if (ressponse.status === 422) {
                        flashMessageContent = "Obsah zprávy byl detekován jako spam.";
                    }

                    $('.js-flash-message-container').html(`<div class="o-flash-message o-flash-message--visible o-flash-message--error">${flashMessageContent}</div>`);

                }
            });
        }

        return false;
    });

    // Open order modal

    if ($("#open-order-modal").val()) {
        OpenOrderModal();
    }

    if (window.location.hash === "#order") {
        window.location.hash = "";
        
        // Check if user is logged in
        if ($('.js-log-in').length) {
            // set timeout 
            debounce(function () {
                // Check if adult popup is displayed
                if (!$('.js-warning-popup').length) {
                    // We need to first set fragment to know where to return from login
                    // Update hash to open order popup after login
                    window.location.hash = "order"
                    $('.js-log-in').trigger('click');
                } else {
                    // Update hash to login after confirming the adult popup
                    window.location.hash = "login";
                }
            }, 500)();

        } else {
            OpenOrderModal();
        }
    }

    $(document).on('click', '#order-button', function (e) {
        e.preventDefault();
        OpenOrderModal();
    })

    // 18+ popup

    $(document).on('click', '.js-close-warning-popup', function (e) {
        e.preventDefault();
        $.ajax({
            url: '/Users/GrantIsAdultConsent',
            success: function () {
                $('.js-warning-popup').removeClass('c-popup--visible');

                if (window.location.hash === '#login' && $('.js-log-in').length) {
                    $('.js-log-in').trigger('click');
                    window.location.hash = "";
                }
            }
        });
    });

    // Smaller price

    if($('.js-ad-detail-price').width() >= 160) {
        $('.js-ad-detail-price').addClass('c-ad-detail__info-price--smaller');
    }

    // Log to Google Analytics message send
    $(document).on('submit', '#send-message', createLogToGoogleOnPostHandler('Inzerat', 'Konverzace'));
    $(document).on('click', '.js-report-button', createLogToGoogleOnPostHandler('Inzerat', 'Nahlasit'));

    function createLogToGoogleOnPostHandler(eventName, subeventName) {
        var eventLoggedToGa = false;
        const adIdentifier = $(".user-ad-identifier").val();
        const rootCategoryName = $(".root-category-name").text();
        const isDirectMessage = $('#js-message-popup-email').length != 0;

        return function (e) {
            if (!eventLoggedToGa) {
                e.preventDefault();

                if ($(this).is('form')) {
                    var $form = $(this);
                    $form.find(':submit').attr('disabled', 'disabled');

                    var formSubmitted = false;

                    function submitForm() {
                        eventLoggedToGa = true;

                        if (!formSubmitted && $form && $form.submit) {
                            formSubmitted = true;
                            $form.submit();
                        }
                    }
                }

                let labelParameter = null;
                if (subeventName === 'Konverzace') {
                    labelParameter = isDirectMessage ? 1 : 0;
                }

                window.dataLayer.push({
                    'event': 'user-action',
                    'category': eventName,
                    'action': subeventName,
                    'label': adIdentifier,
                    'labelParameter': labelParameter,
                    'eventCallback': submitForm,
                    'section': rootCategoryName,
                    'eventTimeout': 1000
                });
            }
        };

        $form.find(':submit').removeAttr('disabled');
    }
});

function OpenOrderModal() {
    const adIdentifier = $(".user-ad-identifier").val();
    return $.hi.order.openAdOrderModal(adIdentifier)
}

function messagePopup() {
    $('.js-message-popup').toggleClass('c-message-popup--visible');
    $('body').toggleClass('u-no-scroll');
    $.validator.unobtrusive.parse("#send-message");
}